import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import highlightedPlayIcon from '../../../assets/images/common/VideoPlayer/highlighted-play-icon.png';
import coloredPlayIcon from '../../../assets/images/common/VideoPlayer/colored-play-icon.png';
import whitePlayIcon from '../../../assets/images/common/VideoPlayer/white-play-icon.png';
import ReactPlayer from 'react-player';
import './NewVideoPlayer.scss';
import i18n from 'i18next';

type Props = {
  imgSrc: string,
  videoSrc: string,
  textColor: 'white' | 'colored',
  title?: string,
  caption?: string,
  isCustom?: boolean,
  ctaHighlighted?: boolean,
  nonClickable?: boolean,
  showVidDirectly?: boolean,
  autoplay?: boolean,
};

type State = {
  isPlaying: boolean,
};

export class NewVideoPlayer extends React.PureComponent<Props> {
  state: State = {
    isPlaying: false,
  };

  componentDidUpdate(prevProps: Props) {
    if ((prevProps.nonClickable !== this.props.nonClickable && this.props.nonClickable) ||
      (prevProps.imgSrc !== this.props.imgSrc) || (prevProps.videoSrc !== this.props.videoSrc)) {
      this.setState({
        isPlaying: false,
      });
    }
  }

  render() {
    const staticView = (
      <div className={`vidStaticView ${this.props.nonClickable ? 'nonClickable' : 'default'}`}>
        <div className="overlay" onClick={() => { !this.props.nonClickable && this.setState({ isPlaying: !this.state.isPlaying }); }}>
          <div className={`wrapper ${this.props.textColor}`}>
            {!this.props.nonClickable && <div className="playGroupMobile">
              <LazyLoadImage src={this.props.textColor === 'white' ? whitePlayIcon : this.props.ctaHighlighted ? highlightedPlayIcon : coloredPlayIcon} />
              <p className={`playCTA ${this.props.ctaHighlighted ? 'highlighted' : 'default'}`}>{i18n.t('components.videoPlayer.cta')}</p>
            </div>}
            {
              this.props.isCustom
                ? <div>
                  {this.props.title && <p className="vidTitle">{this.props.title}</p>}
                  {this.props.caption && <p className="vidCaption">{this.props.caption}</p>}
                  {this.props.children}
                </div>
                : <div>
                  {this.props.title && <p className="vidTitle">{this.props.title}</p>}
                  {this.props.caption && <p className="vidCaption">{this.props.caption}</p>}
                </div>
            }
            {!this.props.nonClickable && <div className="playGroupDesktop">
              <LazyLoadImage src={this.props.textColor === 'white' ? whitePlayIcon : this.props.ctaHighlighted ? highlightedPlayIcon : coloredPlayIcon} />
              <p className={`playCTA ${this.props.ctaHighlighted ? 'highlighted' : 'default'}`}>{i18n.t('components.videoPlayer.cta')}</p>
            </div>}
          </div>
        </div>
        <LazyLoadImage src={this.props.imgSrc} className="videoBg" />
      </div>
    );

    const vidPlayer = (
      <ReactPlayer
        url={this.props.videoSrc}
        playing={this.state.isPlaying || this.props.autoplay}
        controls={true}
        height="100%"
        width="100%"
      />
    );

    return (
      <div className="NewVideoPlayer">
        {
          (this.state.isPlaying || this.props.showVidDirectly)
            ? vidPlayer
            : staticView
        }
      </div>
    );
  }
}